<template>
  <div>
    <div v-for="order in currentList" :key="order._id">
      <b-row class="ml-1 justify-content-center">
        <b-col lg="10">
          <Order v-bind:order="order" />
        </b-col>
      </b-row>
    </div>
    <b-row class="ml-1 justify-content-center">
      <b-col lg="10">
        <b-pagination
          class="mt-3"
          :total-rows="orders.length"
          v-model="currentPage"
          :per-page="perPage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Order from "./Order";


export default {
  name: "OrderList",
  components: {
    Order,
  },

  data() {
    return {
      currentPage: 1,
      perPage: 3,
    };
  },

  computed: {
    ...mapGetters(["orders"]),

    currentList() {
      return this.orders.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
  },


};
</script>

<style scoped></style>
